<template>
  <v-card>
    <v-card-title class="headline"
      >Cancelar enlace de pago
      <v-btn
        style="right: 10px; top: 10px"
        icon
        color="primary"
        fab
        absolute
        @click="$emit('cancel')"
      >
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <h2 class="mt-5">
              ¿Está seguro que desea cancelar el enlace de pago?
            </h2>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-container>
        <v-row class="pl-5 pr-5">
          <v-col cols="6" sm="6" md="6">
            <v-btn
              color="gray"
              rounded
              block
              :min-height="48"
              @click="$emit('cancel')"
            >
              Salir
            </v-btn>
          </v-col>
          <v-col cols="6" sm="6" md="6">
            <v-btn
              color="primary"
              block
              rounded
              :min-height="48"
              @click="$emit('confirm')"
            >
              Cancelar
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ["opl"],
  name: "cancel-opl",

  methods: {},
};
</script>